import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, forwardRef, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-cbb-field',
  templateUrl: './cbb-field.component.html',
  styleUrls: ['./cbb-field.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CbbFieldComponent),
      multi: true,
    },
  ],
})
export class CbbFieldComponent implements ControlValueAccessor {
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() label = '';
  @Input() placeholder = '';
  @Input() type = 'text';
  /** Atributos nativos del input number (flechas del navegador respetan step/min). */
  @Input() min?: number;
  @Input() step?: number;
  @Input() readonly = false;
  @Input() mensajeError = '';
  /** Solo dígitos; elimina otros caracteres al escribir o pegar. */
  @Input() numericOnly = false;
  /** Muestra botón para limpiar el valor actual. */
  @Input() clearable = false;

  value: string | number = '';
  isDisabled = false;

  private onChange: (v: string | number) => void = () => {};
  private onTouched: () => void = () => {};

  onInput(event: Event): void {
    const val = (event.target as HTMLInputElement).value;
    this.value = val;
    this.onChange(val);
  }

  onBlur(): void {
    this.onTouched();
  }

  get canClear(): boolean {
    return this.clearable && !this.readonly && !this.isDisabled && String(this.value ?? '') !== '';
  }

  clearValue(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (!this.canClear) {
      return;
    }
    this.value = '';
    this.onChange('');
    this.onTouched();
    this.cdr.markForCheck();
  }

  writeValue(val: string | number): void {
    this.value = val ?? '';
    this.cdr.markForCheck();
  }

  registerOnChange(fn: (v: string | number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.isDisabled = disabled;
    this.cdr.markForCheck();
  }
}
